export default "__VITE_ASSET__Bu058jR7__"